import React from 'react';

export default function ProductDetailsPreorder({
  productId,
}: {
  productId: string;
}) {
  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://preproduct.onrender.com/preproduct-embed.js';

    script.async = true;

    script.crossOrigin = 'anonymous';

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div className="col-span-2">
      <div
        id="preproduct-pledge"
        data-id={productId?.replace('gid://shopify/Product/', '')}
        data-headless="true"
      ></div>
      {/* <script
        type="text/javascript"
        async
        src="https://preproduct.onrender.com/preproduct-embed.js"
      ></script> */}
    </div>
  );
}
